export default __webpack_public_path__ + "static/media/Fortigate.3507ab75.png";